/* @flow */
import {
  cropableImageModalActionMaker,
  eventSettingsActionMaker,
  cardBgImageActionMaker
} from '@website/components/ActionMakers'
import {
  changeTitle,
  changeTitleAlignment,
  changeParagraphAlignment,
  changeCardBgOverlayTransparency
} from '@website/components/CommonActions'

export default dispatcher => {
  const _changeTitle = (title: string) => {
    dispatcher(changeTitle(title))
  }

  const _changeTitleAlignment = alignment => {
    dispatcher(changeTitleAlignment(alignment))
  }

  const _changeParagraphAlignment = alignment => {
    dispatcher(changeParagraphAlignment(alignment))
  }

  const addImage = () => {
    dispatcher({
      type: 'ADD_IMAGE'
    })
  }

  const addCardImage = () => {
    dispatcher({
      type: 'ADD_CARD_IMAGE'
    })
  }

  const changeSubtitleAlignment = (alignment: string) => {
    dispatcher({
      type: 'CHANGE_SUBTITLE_ALIGNMENT',
      value: alignment
    })
  }

  const changeLocationAlignment = (alignment: string) => {
    dispatcher({
      type: 'CHANGE_LOCATION_ALIGNMENT',
      value: alignment
    })
  }

  const changeDateAlignment = (alignment: string) => {
    dispatcher({
      type: 'CHANGE_DATE_ALIGNMENT',
      value: alignment
    })
  }

  const centerImgActions = (imageUrl: string) => [
    ...cropableImageModalActionMaker(dispatcher)({
      keyForSizes: 'RSVP1CenterImage',
      imageUrl
    })
  ]

  const changeCardImgAction = (value: Object, undoable: boolean) => ({
    type: 'CHANGE_CARD_IMAGE',
    value,
    undoable
  })

  const removeCardImgUrl = () => ({
    type: 'REMOVE_CARD_IMAGE'
  })

  const cardImageActions = (
    imageUrl: string,
    bgOverlayTransparency: number
  ) => [
    ...cardBgImageActionMaker(dispatcher)({
      keyForSizes: 'RSVP1Card',
      actions: {
        changeImage: ({ url, dimensions, undoable }) =>
          dispatcher(changeCardImgAction({ url, dimensions }, undoable)),
        removeImage: removeCardImgUrl,
        changeTransparency: value => {
          dispatcher(changeCardBgOverlayTransparency(value))
        }
      },
      imageUrl,
      bgOverlayTransparency
    })
  ]

  return {
    addImage,
    addCardImage,
    changeTitle: _changeTitle,
    centerImgActions,
    cardImageActions,
    changeTitleAlignment: _changeTitleAlignment,
    changeParagraphAlignment: _changeParagraphAlignment,
    changeSubtitleAlignment,
    changeLocationAlignment,
    changeDateAlignment,
    eventSettingsActionMaker
  }
}
